import {
	confluenceChildPost,
	confluenceChildPut,
	confluenceParentPost,
	confluenceParentPut,
} from './helpers';
import { CONTENT_TYPE_PREFIX, ANSWER_TYPE, QUESTION_TYPE } from '../constants/custom-content';

export const TYPE_COMMENT = 'comment';

export const createAnswerPostPayload = (spaceKey, parentId, title, body) =>
	confluenceChildPost(ANSWER_TYPE, QUESTION_TYPE, spaceKey, parentId, title, body);

export const createAnswerPutPayload = (versionNumber, spaceKey, parentId, title, body) =>
	confluenceChildPut(ANSWER_TYPE, QUESTION_TYPE, spaceKey, parentId, title, body, versionNumber);

export const createCommentPostPayload = (spaceKey, parentType, parentId, body, title = undefined) =>
	confluenceChildPost(
		TYPE_COMMENT,
		`${CONTENT_TYPE_PREFIX}:${parentType}`,
		spaceKey,
		parentId,
		title,
		body,
	);

export const createCommentPutPayload = (
	versionNumber,
	spaceKey,
	parentType,
	parentId,
	body,
	title = undefined,
) =>
	confluenceChildPut(
		TYPE_COMMENT,
		`${CONTENT_TYPE_PREFIX}:${parentType}`,
		spaceKey,
		parentId,
		title,
		body,
		versionNumber,
	);

export const createQuestionPostPayload = (spaceKey, title, body, labels) =>
	Object.assign({}, confluenceParentPost(QUESTION_TYPE, spaceKey, title, body), {
		metadata: {
			properties: {
				atl_cq_has_answers: {
					key: 'atl_cq_has_answers',
					value: {
						has_answers: 'false',
					},
				},
				atl_cq_votes: {
					key: 'atl_cq_votes',
					value: {
						total: 0,
					},
				},
			},
			labels,
		},
	});

export const createQuestionPutPayload = (spaceKey, title, body, versionNumber, labels) =>
	Object.assign({}, confluenceParentPut(QUESTION_TYPE, spaceKey, title, body, versionNumber), {
		metadata: {
			labels,
		},
	});
